import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=305f3305&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Category.vue?vue&type=style&index=0&id=305f3305&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "305f3305",
  "2d2e18ae"
  
)

export default component.exports